import Axios from 'axios';

export const uploadImagemGcp = ({ url, file }) => {
  const options = {
    headers: {
      'Content-Type': 'application/octet-stream'
    }
  };

  return Axios.put(url, file, options);
};

export default { uploadImagemGcp };
